
import { useState } from "react";
import { Button } from "primereact/button";
import { CodeEditor } from "../code/CodeEditor";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { ErrorDefaultValueWidget } from "../error/errorDefaultValueWidget";

export const CodeEditorInDialog = ({lang ,defaultValue, onChange, buttonType, buttonValue}: 
    {lang: string,defaultValue:string , onChange: (value: any) => void, buttonType:string, buttonValue:string }
) => {
  const [dialogVisibility, setDialogVisibility] = useState<boolean>(false);

  const [incorrectDefaultValue, setIncorrectDefaultValue] =
  useState<boolean>(false);

  const verifyType = (value: any) => {
    return typeof value === "string";
  };


  const [codeEditorValue, setCodeEditorValue] = useState<any>(
    () => {
      if (defaultValue) {
        if (verifyType(defaultValue)) return defaultValue;
        else setIncorrectDefaultValue(true);
      }
      return "";
    }
  );
  const [unsaved, setUnsaved] = useState<boolean>(false);

  const footer = () => {
    return (
      <div className="flex justify-content-end mt-1">
        <Button
          label={"ANNULER"}
          type="button"
          onClick={() => {
            if (unsaved) {
              confirmDialog();
            } else {
              setDialogVisibility(false);
              setUnsaved(false);
            }
          }}
          className="m-2 p-button-outlined p-button-sm"
        />

        <Button
          label={"SAUVEGARDER"}
          type="button"
          onClick={() => {
            onChange(codeEditorValue);
            setIncorrectDefaultValue(false)
            setDialogVisibility(false);
            setUnsaved(false);
          }}
          className="m-2 p-button-sm"
        />
      </div>
    );
  };

  const header = () => {
    return (
      <div className="flex justify-content-between">
        <div>Editer ({lang})</div>

        <div>
          {unsaved && (
            <div className="mr-2">
              <Message
                text="Des changements n'ont pas été enregistrés"
                severity="info"
                icon="pi pi-save"
                className="mr-1"
                style={{ height: "0.7rem" }}
              ></Message>
            </div>
          )}
        </div>
      </div>
    );
  };

  const confirmDialog = () => {
    if (
      window.confirm(
        "Etes vous sûr de vouloir quitter la pop-up sans enregistrer vos modifications ?"
      )
    ) {
      setDialogVisibility(false);
      setUnsaved(false);
    }
  };

  return (
    <div>
      <Dialog
        header={header}
        visible={dialogVisibility}
        className={"app-dialog"}
        onHide={() => {
          if (unsaved) {
            confirmDialog();
          } else {
            setDialogVisibility(false);
            setUnsaved(false);
          }
        }}
        footer={footer}
      >
        <CodeEditor
          defaultValue={codeEditorValue}
          lang={lang}
          valueUpdated={(value) => {
            setCodeEditorValue(value);
            setUnsaved(true);
          }}
        />
      </Dialog>
      <ErrorDefaultValueWidget displayError={incorrectDefaultValue} ></ErrorDefaultValueWidget>
      <Button
        label={buttonType === 'text' ? buttonValue : undefined}
        onClick={() => setDialogVisibility(true)}
        className="mr-3 p-button-outlined p-button-sm"
        icon={buttonType === 'icon' ? buttonValue : undefined}
      />
    </div>
  );
};
